/**
 * @generated SignedSource<<6211b1e88960b44735307bbfe4e58f43>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "biId",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "boId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "BusinessBeneficialOwnerUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateBeneficialOwnerTPayload",
        "kind": "LinkedField",
        "name": "updateBeneficialOwnerTByBoId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BeneficialOwnerT",
            "kind": "LinkedField",
            "name": "beneficialOwnerT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "BusinessBeneficialOwnerUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateBeneficialOwnerTPayload",
        "kind": "LinkedField",
        "name": "updateBeneficialOwnerTByBoId",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BeneficialOwnerT",
            "kind": "LinkedField",
            "name": "beneficialOwnerT",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "nodeId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8638109c2d70f1127efa46debfa04246",
    "id": null,
    "metadata": {},
    "name": "BusinessBeneficialOwnerUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation BusinessBeneficialOwnerUpdateMutation(\n  $input: UpdateBeneficialOwnerTByBoIdInput!\n) {\n  updateBeneficialOwnerTByBoId(input: $input) {\n    beneficialOwnerT {\n      biId\n      boId\n      nodeId\n    }\n  }\n}\n"
  }
};
})();

node.hash = "a89904902a3968f74c97e4a1040f4241";

module.exports = node;
